import { useRef, useState } from "react";
import { api } from "../api";

interface Props {
  value: string | null;
  onChange: (filename: string | null) => void;
}

export function ImagePickerButton({ value, onChange }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setError(null);
    setUploading(true);
    try {
      const res = await api.uploadImage(file);
      onChange(res.filename);
    } catch (err) {
      setError(err instanceof Error ? err.message : "upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  }

  return (
    <>
      <label className="btn-secondary inline-block cursor-pointer text-xs px-2 py-1 whitespace-nowrap">
        {uploading ? "Uploading…" : value ? "Replace image" : "+ image"}
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onFile}
          disabled={uploading}
        />
      </label>
      {error && <div className="text-rose-400 text-sm">{error}</div>}
    </>
  );
}

export function ImagePreview({ value, onChange }: Props) {
  if (!value) return null;
  return (
    <div className="flex items-center gap-3">
      <img src={api.imageUrl(value)} alt="" className="max-h-32 rounded-lg" />
      <button
        type="button"
        onClick={() => onChange(null)}
        className="btn-secondary text-sm"
      >
        Remove
      </button>
    </div>
  );
}

export default function ImagePicker(props: Props) {
  return (
    <div className="space-y-2">
      <ImagePreview {...props} />
      <ImagePickerButton {...props} />
    </div>
  );
}
